import { useTranslation } from "react-i18next";
import Card from "../../common/components/Card";
import CustomForm from "../../common/components/CustomForm";
import { Col, Container, Row } from "../../common/components/Grid";
import Label from "../../common/components/Label";
import useClientConfig from "../../common/hooks/clientConfigHook";
import EpcrAcuityDropdown from "./EpcrAcuityDropdown";
import { useEpcrEditorEpcr, useEpcrEditorIntent } from "./EpcrContext";
import PropTypes from 'prop-types';
import { useMemo } from "react";
import { customCtrlTypeSupported } from "../../common/components/DataTable";
import EpcrComplaintInput from "./EpcrComplaintInput";
import { deepClone } from "../../common/utils/objectUtilities";

const EpcrNarrative = ({ disabled = false}) => {
    const { t } = useTranslation();
    const clientConfig = useClientConfig();
    const { epcr, site, level, type, update } = useEpcrEditorEpcr();
    const intent = useEpcrEditorIntent();

    const def = useMemo(() => {
        if (intent === 'search' && clientConfig.epcrEventFormSpec) {
            let def = deepClone(clientConfig.epcrEventFormSpec);
            def.forEach(section => {
                section.rows = section.rows.map(row => row.filter(cell => customCtrlTypeSupported(cell)));
                section.rows = section.rows.filter(row => row.length > 0);
            });
            def = def.filter(section => section.rows.length > 0);
            return def;
        }
        return clientConfig.epcrEventFormSpec;
    }, [intent, clientConfig.epcrEventFormSpec]);

    return <Container fluid>
        <Card>
            <Row>
                <Col md={4}><Label hideLabel={true} text={`${t('chiefComplaint')}:`}></Label></Col>
                <Col md={8}><EpcrComplaintInput hideLabel={true} site={site} type={type} level={level} value={epcr?.problem} placeholder={t('chiefComplaint')} disabled={disabled} onChange={p => update('problem', p)}></EpcrComplaintInput></Col>
            </Row>
            <Row>
                <Col md={4}><Label hideLabel={true} text={t('secondaryComplaint')}></Label></Col>
                <Col md={8}><EpcrComplaintInput hideLabel={true} site={site} type={type} level={level} value={epcr?.problem2} placeholder={t('secondaryComplaint')} disabled={disabled} onChange={p => update('problem2', p)}></EpcrComplaintInput></Col>
            </Row>
            <Row>
                <Col md={4}><Label hideLabel={true} text={t('initialPatientAcuity')}></Label></Col>
                <Col md={8}><EpcrAcuityDropdown hideLabel={true} acuity={epcr?.initialpatientacuity} placeholder={t('initialPatientAcuity')} disabled={disabled} onChange={a => update('initialpatientacuity', a)}></EpcrAcuityDropdown></Col>
            </Row>
            {clientConfig.epcrEventFormSpec ? <CustomForm disabled={disabled} hideLabel={true} def={def} data={epcr?.eventcustomfields ?? {}} onChange={c => update('eventcustomfields', c)}></CustomForm> : null }
        </Card>
    </Container>
}

EpcrNarrative.propTypes = {
    type: PropTypes.string,
    site: PropTypes.string,
    level: PropTypes.string,
    disabled: PropTypes.bool
}

export default EpcrNarrative;